import { InferType, number, object, string } from 'yup'
import { checkMedicare, checkMedicareExpiry } from '@/lib/utils'

export const BaseMedicareFormValidator = object({
  number: string()
    .default('')
    .required('Please enter your Medicare number.')
    .test({
      name: 'is-valid-medicare',
      skipAbsent: false,
      test(value, ctx) {
        const err = checkMedicare(value)
        if (err !== null) {
          return ctx.createError({ message: err })
        }

        return true
      },
    }),
  irn: number().test({
    name: 'is-required',
    skipAbsent: false,
    test(value, ctx) {
      if (value === null || value === undefined || `${value}`.length === 0)
        return ctx.createError({ message: 'IRN Number is required' })

      return true
    },
  }),
  expiry: string()
    .default('')
    .required('Please enter Expiry in MM/YYYY format.')
    .test({
      name: 'is-valid-medicare-expiry',
      skipAbsent: false,
      test(value, ctx) {
        const err = checkMedicareExpiry(value)
        if (err !== null) {
          return ctx.createError({ message: err })
        }

        return true
      },
    }),
})

export interface BaseMedicareFormType
  extends InferType<typeof BaseMedicareFormValidator> {}

export const MedicareFormValidator = BaseMedicareFormValidator.shape({
  irn: number().test({
    name: 'is-required',
    skipAbsent: false,
    test(value, ctx) {
      if (value === null || value === undefined)
        return ctx.createError({ message: 'IRN Number is required' })

      return true
    },
  }),
})
